import React from "react";
import { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "../../../inventory/DetailsView/details-table/details-table.component";

export class AccountCostAllocation extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            showTable:false,
        }
    }
    ShowTable() {
        this.setState({showTable:!this.showTable})
    }
    render() {
        return(
            <div className="">
                <div className="grid-3-1fr-column mb-2">
                    <InputField label="GL CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                    <div></div>
                    <div></div>
                    <InputField label="COST CENTER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                    <InputField label="PERCENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                    <div className="add-button-container ">
                        <Button>Cancel</Button>
                        <Button onClick={this.ShowTable.bind(this)}>Add</Button>
                    </div>                
                </div>
                {
                    this.state.showTable && 
                    <DetailsDataTable datatable={this.props.datatable} haveEditBtn={this.props.haveEditBtn} haveDeleteBtn={this.props.haveDeleteBtn} />       
                }
             </div>
        );
    }
}